export const GET_SETTINGS_DETAIL = 'GET_SETTINGS_DETAIL';
export const SET_SETTINGS_SAVING = 'SET_SETTINGS_SAVING';
export const SAVE_SETTINGS = 'SAVE_SETTINGS';
export const SET_SETTINGS_LOADING = 'SET_SETTINGS_LOADING';
export const SET_SETTINGS_FORM_DATA = 'SET_SETTINGS_FORM_DATA';